import {
  ExReleaseDraftsService,
  type InitExReleaseDraftDTO,
} from "../../../api/exReleaseDrafts"
import { ExReleasesService } from "../../../client"
import { useCreateWarehouseDocumentDraft } from "../shared/useCreateWarehouseDocumentDraft"

export function useCreateWZ() {
  const { createDocument, isCreating, isResolvingWarehouses, canCreate } =
    useCreateWarehouseDocumentDraft({
      mutationKey: ["wms", "ex-releases"] as const,
      documentCode: "WZ",
      blockedWarehouseDescription:
        "Magazyn źródłowy z kontekstu jest obecnie zablokowany przez aktywną inwentaryzację.",
      missingWarehouseDescription:
        "Brak aktywnego magazynu dostępnego do utworzenia dokumentu WZ.",
      createDraftRequest: async (
        payload: InitExReleaseDraftDTO,
        options?: any,
      ) => {
        const draft = await ExReleaseDraftsService.initExReleaseDraft(payload)
        if (options?.prefilledItems && options.prefilledItems.length > 0) {
          await ExReleasesService.updateExReleaseByID(draft.id, {
            items: options.prefilledItems.map(
              (item: any) =>
                ({
                  product_id: item.product_id,
                  qty: item.qty,
                  location_code: item.location_code,
                  warehouse_lot_id: item.warehouse_lot_id,
                  partia: item.partia,
                  lot_no: item.lot_no,
                  production_date: item.production_date,
                  expiration_date: item.expiration_date,
                }) as any,
            ),
          })
        }
        return draft
      },
      buildPayload: (warehouseId: string) => ({
        warehouse_id: warehouseId,
      }),
      getSuccessNavigation: (draft) => ({
        to: "/WMS/documents/ex-releases/$exRelease",
        params: { exRelease: draft.id },
        search: { tab: "general", mode: "edit" },
      }),
    })

  return {
    createWZ: (preferredWarehouseId?: string, items?: any[]) =>
      createDocument({ preferredWarehouseId, prefilledItems: items } as any),
    isCreating,
    isResolvingWarehouses,
    canCreate,
  }
}
